/**
 * @prettier
 */

import { DashboardPage as Dashboard } from "./Dashboard";

export default Dashboard;
